import React from "react";
import Dropdown from "react-bootstrap/Dropdown";
import DropdownButton from "react-bootstrap/DropdownButton";
import {useSelector} from "react-redux";
import ArchiveItemsBlock from "../../../archive-items-block";

const ArchiveBlock = () => {
    const {ak_au_ph_archive} = useSelector((state) => {
        return state.lots.phrases
    });

    return (
        <div className="ms-1">
            <Dropdown>
                <DropdownButton
                    size='sm'
                    variant="info btn-rg"
                    id="dropdown-archive"
                    title={ak_au_ph_archive}>
                    <ArchiveItemsBlock/>
                </DropdownButton>
            </Dropdown>
        </div>
    )
}

export default ArchiveBlock